import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styled from 'styled-components'
import moment from 'moment'
import { useToasts } from 'react-toast-notifications'

import Table from '../../../../components/Table'
import Flex from '../../../../components/layouts/Flex'
import TableTag from '../../TableTag'

import { P } from '../../../../style/Typography.style'

import axiosInstance from '../../../../services/config/AxiosIntance'
import { setApplicantListUrl } from '../../../../store/actions/recruitersActions'

const Withdrawn = ({ onRowClick }) => {
  const dispatch = useDispatch()

  const { addToast } = useToasts()
  const { filters, updatedStage, changedInterviews } = useSelector(
    (state) => state.requisitions
  )

  const [interviews, setInterviews] = useState([])
  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [loading, setLoading] = useState(true)
  const [rowCount, setRowCount] = useState(0)

  const currentUser = localStorage.getItem('user')
  const role = JSON.parse(currentUser)?.user_type
  const userId = JSON.parse(currentUser)?.id
  const recruiterAssistant = !!JSON.parse(currentUser)?.recruiter_assistant

  const companyDetails =
    role === 'poc' && JSON.parse(currentUser)?.companyDetails

  const stage = 'withdrawn'

  let url = `/interviews?stage=${stage}&searchTerm=${filters.search}&job_title=${filters.searchRole}&vacancy=${filters.vacancy}&startDate=${filters.startDate}&endDate=${filters.endDate}&sort=${filters.sort}&readBy=${userId}&smartSearchId=${filters.smartSearchId}`

  if (!recruiterAssistant && role === 'recruiter') {
    url += `&recruiterId=${userId}`
  } else if (role === 'poc') {
    url += `&companyDetails=${JSON.stringify(companyDetails)}`
  }

  const fetchData = useCallback(async (url) => {
    setLoading(true)
    try {
      const result = await axiosInstance.get(url)

      const { data } = result

      dispatch(setApplicantListUrl(url))

      setTotalPage(data?.resp?.pagination?.pageCount || 1)
      setCurrentPage(data?.resp?.pagination?.page || 1)
      setPageSize(data?.resp?.pagination?.pageSize || 10)
      setRowCount(data?.resp?.pagination?.rowCount || 0)

      setInterviews(data?.resp?.interviews || [])
      setLoading(false)
    } catch (err) {
      addToast(err?.response?.data?.message, {
        appearance: 'error',
        autoDismiss: true,
      })
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (interviews.length && changedInterviews.length) {
      const updatedInterviews = interviews.map((item) => {
        const replacement = changedInterviews.find((t) => t.id === item.id)
        return replacement || item
      })

      setInterviews(updatedInterviews)
    }
  }, [changedInterviews])

  useEffect(() => {
    fetchData(url)
  }, [filters])

  useEffect(() => {
    if (updatedStage === 'closed') fetchData(url)
  }, [updatedStage])

  const columns = React.useMemo(
    () => [
      {
        Header: 'Applicant',
        accessor: 'applicantName',
      },
      {
        Header: 'Expected Salary',
        accessor: 'salaryRange',
      },
      {
        Header: 'Role',
        accessor: 'role',
      },
      {
        Header: 'Email',
        accessor: 'email',
      },
      {
        Header: 'Client',
        accessor: 'client',
      },
      {
        Header: 'Contact No.',
        accessor: 'contact',
      },
      {
        Header: 'Recruiter',
        accessor: 'recruiter',
      },
      {
        Header: 'Interview Status',
        accessor: 'interviewStatus',
        Cell: ({ row }) => {
          if (row?.original?.interviewStatus === 'Accepted') {
            return <TableTag status="approved" content="Accepted" />
          } else if (row?.original?.interviewStatus === 'In_progress') {
            return <TableTag status="pending" content="In Progress" />
          } else {
            return (
              <TableTag
                status="rejected"
                content={row?.original?.interviewStatus}
              />
            )
          }
        },
      },
      {
        Header: 'Channel',
        accessor: 'channel',
      },
      {
        Header: 'Asking Salary',
        accessor: 'asking_salary',
      },
      {
        Header: 'Date Created',
        accessor: 'dateCreated',
        Cell: ({ value }) => (value ? moment(value).format('DD/MM/YYYY') : ''),
        sortType: 'datetime',
      },
      {
        Header: 'Last Updated',
        accessor: 'lastUpdated',
        Cell: ({ value }) => (value ? moment(value).format('DD/MM/YYYY') : ''),
        sortType: 'datetime',
      },
    ],
    []
  )

  const getInterviewStatus = (item) => {
    if (item) {
      if (item?.interviewStatus === 'Rejected') {
        if (item?.rejectionType) {
          return `Rejected - ${item?.rejectionType}`
        } else {
          return 'Rejected'
        }
      } else {
        return item?.interviewStatus
      }
    }
  }

  const tableData = interviews.map(
    (item) =>
      ({
        actions: item,
        readApplicantId: item.readApplicantId,
        applicantName: item.applicantName || '',
        applicantMinSalary: item.applicantMinSalary,
        applicantMaxSalary: item.applicantMaxSalary,
        salaryRange: `${item.applicantCurrency || ''}  ${
          item.applicantMinSalary || '0'
        } - ${item.applicantMaxSalary || '0'}`,
        role: item.role || '',
        email: item.applicantEmail || '',
        client: item.client || '',
        contact: item.mobileNumber || '',
        recruiter: item.recruiterName || '',
        interviewStatus: getInterviewStatus(item) || '',
        jobStatus: item.jobStatus || '',
        schedule:
          moment(item.interview_date).format('DD/MM/YYYY') +
            ' • ' +
            moment(item.interview_time).format('hh:mm a') || '',
        addedBy: item.added_by || '',
        channel: item.channel || '',
        askingSalary: item.askingSalary || '',
        dateCreated: item.created_at ? new Date(item.created_at) : null,
        lastUpdated: item.updated_at ? new Date(item.updated_at) : null,
      } || '')
  )

  return (
    <StyledWithdrawn>
      {interviews?.length > 0 ? (
        <Table
          data={tableData}
          columns={columns}
          loading={loading}
          totalPage={totalPage}
          currentPage={currentPage}
          pageSize={pageSize}
          rowCount={rowCount}
          fetchData={fetchData}
          setNewPageSize={setPageSize}
          setCurrentPage={setCurrentPage}
          url={`${url}&pageNumber=${currentPage}&pageSize=${pageSize}`}
          noData="Withdrawn page is empty"
          height="calc(100vh - 20.3rem)"
          onClick={onRowClick}
        />
      ) : (
        <Flex
          height="calc(100vh - 15rem)"
          bg="#fff"
          justify="center"
          items="center"
        >
          <P>Withdrawn page is empty</P>
        </Flex>
      )}
    </StyledWithdrawn>
  )
}

export default Withdrawn

const StyledWithdrawn = styled.div`
  width: 100%;
  height: 100%;
`
